var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg pa-2 white",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"secondary--text"},[_vm._v(" نمودار تنخواه "),_c('v-spacer'),_c('chart-export-btn',{attrs:{"page-chart-id":"imprest-chart"}})],1),_c('canvas',{attrs:{"id":"imprest-chart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }